import { render, staticRenderFns } from "./FixedTabList.vue?vue&type=template&id=7933a5a9&scoped=true&"
import script from "./FixedTabList.vue?vue&type=script&lang=js&"
export * from "./FixedTabList.vue?vue&type=script&lang=js&"
import style0 from "./FixedTabList.vue?vue&type=style&index=0&id=7933a5a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7933a5a9",
  null
  
)

export default component.exports